/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Prompt_Placeholder_StartInputs */



/**
* | output |
* | --- |
* | "Where should we start?" |
*
* @param {Chat_Prompt_Placeholder_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_prompt_placeholder_start = /** @type {((inputs?: Chat_Prompt_Placeholder_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Prompt_Placeholder_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Womit fangen wir an?")
	return /** @type {LocalizedString} */ ("Where should we start?")
});